export const experiences = [
    "Intern Fullstack Developer-kodecamp",
    "Intern Backend Developer-HNG",
    "Freelance Frontend Developer-onicon",
    "Backend Developer-InstaOps",
    "Fullstack Developer-SkyStudio",
 
]